import ApplicationModel, { attr } from '../ApplicationModel';
import { type KnowledgeBaseAttributes } from './generated/KnowledgeBaseAttributes';
import { model } from '../modelBuilder';
import { type KnowledgeBaseAuthenticationMethodEnum_value } from './generated/types';

interface KnowledgeBase extends KnowledgeBaseAttributes {}

@model
class KnowledgeBase extends ApplicationModel {
  static AUTHENTICATION_METHOD_NONE: KnowledgeBaseAuthenticationMethodEnum_value =
    'NONE';
  static AUTHENTICATION_METHOD_PASSWORD: KnowledgeBaseAuthenticationMethodEnum_value =
    'PASSWORD';
  static AUTHENTICATION_METHOD_SSO: KnowledgeBaseAuthenticationMethodEnum_value =
    'SSO';

  // Start auto-generated
  static typename: 'KnowledgeBase' = 'KnowledgeBase';
  get typename(): 'KnowledgeBase' {
    return 'KnowledgeBase';
  }

  static internalTypename: 'KnowledgeBase' = 'KnowledgeBase';
  get internalTypename(): 'KnowledgeBase' {
    return 'KnowledgeBase';
  }

  static inputType = 'KnowledgeBaseAttributes!';

  static fields = {
    authenticationMethod: attr({ writable: true, readable: true }),
    configuration: attr({ readable: true, json: true }),
    enabled: attr({ writable: true, readable: true }),
    id: attr({ readable: true }),
    pageId: attr({ readable: true }),
    password: attr({ writable: true, readable: false }),
    passwordConfirmation: attr({ writable: true, readable: false }),
    passwordIsSet: attr({ readable: true }),
    rootPagesCount: attr({ readable: true }),
    rootUrl: attr({ readable: true }),
    page: attr.belongsTo({
      writeShape: ['id'],
      readable: true,
      typename: 'Page',
    }),
    rootPages: attr.hasMany({ readable: true }),
  };
  // End auto-generated

  authenticationDescripton() {
    switch (this.authenticationMethod) {
      case KnowledgeBase.AUTHENTICATION_METHOD_NONE:
        return 'Public';
      case KnowledgeBase.AUTHENTICATION_METHOD_PASSWORD:
        return 'Password';
      case KnowledgeBase.AUTHENTICATION_METHOD_SSO:
        return 'Single sign-on';
      default:
        return 'Unknown';
    }
  }
}

export default KnowledgeBase;
